import { TableCell } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getCurrencySymbol } from "../format-utils"
import { CostFigure } from "./cost-figure"

export function ComparisonTradeBreakdownCell({ item: variant }) {
    const { tradeName, lowestCost } = useBoundContext()
    const trade = (variant?.costResult?.tradeBreakdown ?? []).find(matchesTradeName)
    const cost = trade?.totalCost ?? 0
    const currencySymbol = getCurrencySymbol(variant?.costResult?.currency || variant?.rateCardCurrency)
    const isLowest = lowestCost != null && cost === lowestCost && cost > 0
    const fontWeight = getFontWeight()
    const color = getColor()

    return (
        <TableCell align="right">
            <CostFigure value={cost} currencySymbol={currencySymbol} fontWeight={fontWeight} color={color} />
        </TableCell>
    )

    function matchesTradeName(t) {
        return t.tradeName === tradeName
    }

    function getFontWeight() {
        if (isLowest) return 700
        return 400
    }

    function getColor() {
        if (isLowest) return "success.main"
        return "text.primary"
    }
}
